import { privateAxios } from "../axiosInstances";
import { useQuery } from "@tanstack/react-query";
import { postersQueryKeys } from "../query-keys";
import { PosterStyle } from "@ac-expo/api-types";

const getPosterStyles = async () => {
  const { data } = await privateAxios.get<PosterStyle[]>(`/posters/styles`);
  return data;
};

export const useGetPosterStyles = () => {
  return useQuery({
    queryKey: postersQueryKeys.list(),
    queryFn: () => getPosterStyles(),
  });
};
